import { Chip } from '@material-ui/core'
import clsx from 'clsx'

import useStyles from './styles'
import preRegistration from 'constants/preRegistration'

const ChipPreRegistration = ({ status }) => {
  const classes = useStyles()

  return (
    <Chip
      size="small"
      className={clsx(
        classes.chip,
        classes[preRegistration.CHIP_COLOR[status]] || classes.black,
      )}
      label={preRegistration.CHIP_LABEL[status] || status || 'Indefinido'}
    />
  )
}

export default ChipPreRegistration
